/**
 * Hash routing: #/assistant, #/documents ... Works on any static host with no
 * server rewrites, which keeps deployment to "upload the build folder".
 */

import { useEffect, useState } from 'react';

export const ROUTES = [
  { path: '#/', label: 'Overview' },
  { path: '#/calculator', label: 'Loan calculator' },
  { path: '#/assistant', label: 'Assistant' },
  { path: '#/documents', label: 'Documents' },
  { path: '#/estimate', label: 'Estimate' },
  { path: '#/scenarios', label: 'Scenarios' },
  { path: '#/readiness', label: 'Readiness' },
  { path: '#/plan', label: 'Action plan' },
] as const;

export type RoutePath = (typeof ROUTES)[number]['path'] | '#/model' | '#/privacy';

function current(): string {
  const h = window.location.hash;
  return h && h.startsWith('#/') ? h.split('?')[0]! : '#/';
}

export function useHashRoute(): string {
  const [route, setRoute] = useState(current);
  useEffect(() => {
    const on = () => {
      setRoute(current());
      window.scrollTo({ top: 0 });
      // Move focus to the page heading for screen-reader and keyboard users.
      requestAnimationFrame(() => document.querySelector<HTMLElement>('main h1')?.focus());
    };
    window.addEventListener('hashchange', on);
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return route;
}

export function go(path: string): void {
  window.location.hash = path.replace(/^#/, '');
}
